import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'gung-standard';

@Component({
    selector: 'colmec-product-symbols',
    templateUrl: './colmec-product-symbols.component.html',
    styleUrls: ['./colmec-product-symbols.component.scss'],
    standalone: false
})
export class ColmecProductSymbolsComponent implements OnInit {
  @Input() product: Product;
  symbols: { id: string; imgSrc: string }[] = [];

  constructor() {}

  ngOnInit() {
    this.setSymbols();
  }

  setSymbols(): void {
    if (Number(this.product.extra.ar?.varugruppkod) === 130) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/environmental.png'
      });
    }
    if (Number(this.product.extra.ar?.varugruppkod) === 190 || Number(this.product.extra.ar?.varugruppkod) === 10) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/environment.png'
      });
    }
    if (Number(this.product.extra.ar?.varugruppkod) === 10) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/ikon_colmec_sverige.png'
      });
    }
    if (this.product.extra.ar?.q_3pmsf) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/3pmsf.png'
      });
    }
    if (['10', '30'].indexOf('' + this.product.extra.ar?.itemtypecd6) >= 0) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/remotedrive.png'
      });
    }
    if (['20', '30'].indexOf('' + this.product.extra.ar?.itemtypecd6) >= 0) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/regionaldrive.png'
      });
    }
    if (this.product.extra.ar?.itemtypecd6 === 80) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/industrydrive.png'
      });
    }
    if (this.product.extra.ar?.itemtypecd6 === 60) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/winterdrive.png'
      });
    }
    if (this.product.extra.ar?.itemtypecd6 === 40) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/citydrive.png'
      });
    }
    if (this.product.extra.ar?.q_ms) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/m_plus_s.png'
      });
    }
    if (this.product.extra.ar?.itemtypecd6 === 90) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/summer.png'
      });
    }
    if (this.product.extra.ar?.itemtypecd6 === 50) {
      this.symbols.push({
        id: '',
        imgSrc: 'assets/mixed_service.png'
      });
    }
  }
}
